import styles from './RefinanceCalculatorItem.module.css';
import { Icon, NumericInput } from '@blueprintjs/core';
import { BlueprintIcons_16Id } from '@blueprintjs/icons/lib/esm/generated/16px/blueprint-icons-16';
import { classNames } from '@axo/shared/util/dom';
import { currencyFormatter } from '../../../utils/formatCurrency';
import { Currency } from '@axo/shared/data-access/types';
import { useState } from 'react';
import { IconButton } from '../../IconButton';

export interface RefinanceCalculatorItemProps {
  icon?: BlueprintIcons_16Id;
  intent: 'none' | 'primary' | 'warning' | 'empty';
  title: string;
  amount: number;
  editable?: boolean;
  secondaryTitle?: string;
  secondaryValue?: string;
  setValue?: (value: number) => void;
  currency?: Currency;
}

export const RefinanceCalculatorItem = ({
  icon,
  intent,
  title,
  amount,
  editable,
  setValue,
  currency,
  secondaryTitle,
  secondaryValue,
}: RefinanceCalculatorItemProps) => {
  const formatAmount = currencyFormatter(currency);
  const [inEditMode, setInEditMode] = useState(false);
  const [currentValue, setCurrentValue] = useState(amount);

  const submitEdit = () => {
    setInEditMode(false);
    setValue?.(currentValue);
  };

  return (
    <div className={classNames(styles.container, intent)}>
      {icon && <Icon icon={icon} className={styles.icon} size={14} />}
      <form className={styles.form} onSubmit={submitEdit}>
        <div className={styles.content}>
          <span className={styles.title}>{`${title} ${
            secondaryTitle ? ' / ' + secondaryTitle : ''
          }`}</span>
          {editable && inEditMode ? (
            <NumericInput
              type="number"
              value={currentValue}
              onValueChange={(value) => setCurrentValue(value)}
              buttonPosition={'none'}
              className={styles.input}
            />
          ) : (
            <span>
              <span className={styles.amount}>{formatAmount(amount)}</span>
              {secondaryValue && (
                <>
                  <span> / </span>
                  <span className={styles.amount}>{secondaryValue}</span>
                </>
              )}
            </span>
          )}
        </div>
        {editable && (
          <div className={styles.edit}>
            {inEditMode ? (
              <IconButton onClick={submitEdit} icon={'tick'} />
            ) : (
              <IconButton
                icon={'edit'}
                onClick={(e) => {
                  e.preventDefault();
                  setInEditMode(true);
                }}
              />
            )}
          </div>
        )}
      </form>
    </div>
  );
};
